import Proxy from './Proxy';

class AuthorityProxy extends Proxy {

  constructor(parameters = {}) {
    super('api/settings/authority', parameters);
  }

  /**
   * 권한 삭제
   * @param menuSeq
   * @param roleCode
   * @returns {Promise}
   */
  deleteAuthority(menuSeq, roleCode) {
    return this.submit('delete', `/${this.endpoint}/${menuSeq}/role-code/${roleCode}`);
  }

  /**
   * 조회권한
   * @param roleCode
   * @param authType
   * @returns {Promise}
   */
  getRoleAuth(roleCode, authType) {
    return this.submit('get', `/${this.endpoint}/role-auth/${roleCode}/auth-type/${authType}`);
  }

  /**
   * 조회권한 삭제
   * @param roleCode
   * @param authType
   * @param authValue
   * @returns {Promise}
   */
  deleteRoleAuth(roleCode, authType, authValue) {
    return this.submit('delete', `/${this.endpoint}/role-auth/${roleCode}/auth-type/${authType}/auth-value/${authValue}`);
  }

  /**
   * 조회권한 설정
   * @param params
   * @returns {Promise}
   */
  createRoleAuth(params) {
    return this.submit('post', `${this.endpoint}/role-auth`, params);
  }
}

export default AuthorityProxy;
